module.exports = __webpack_public_path__ + "img/jxk_bjdx.f16134f7.svg";